import styled from "@emotion/styled"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import { SkeletonCheckbox } from "./SkeletonCheckbox"
import { SkeletonText } from "./SkeletonText"

interface SkeletonCheckboxGroupProps {
	className?: string
	count?: number
	withLabel?: boolean
}

export const SkeletonCheckboxGroup = ({ className, count = 4, withLabel }: SkeletonCheckboxGroupProps) => (
	<Wrapper className={className}>
		{withLabel && <StyledSkeletonText />}
		{Array.from({ length: count }, (_, i) => (
			<SkeletonCheckbox key={i} />
		))}
	</Wrapper>
)

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticSm};
`

const StyledSkeletonText = styled(SkeletonText)`
	width: 25%;
`
